import React, { useState } from "react";

import "./style.css";

import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";

import RestaurantList from "./RestaurantList";

export default function HomePage() {
  const [city, setCity] = useState("amsterdam");

  return (
    <body>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ marginLeft: "0.5%" }}>
          <FormControl sx={{ m: 1, minWidth: 200, float: "left" }}>
            <InputLabel id="demo-simple-select-standard-label">
              Choose a city
            </InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={city}
              onChange={(event) => {
                setCity(event.target.value);
              }}
              label="Choose a city"
            >
              <MenuItem value={"amsterdam"}>Amsterdam</MenuItem>
              <MenuItem value={"utrecht"}>Utrecht</MenuItem>
            </Select>
          </FormControl>
        </div>

        <RestaurantList city={city} />
      </div>
    </body>
  );
}
